import { useOutletContext } from "react-router-dom";
import HeroServices from "./sections/HeroServices";
import ThirdSection from "./sections/thirdsection";
import HeroSectionPrime from "../../components/HeroSectionPrime";
import SectionEight from "./sections/sectionEight";
import SectionNine from "./sections/sectionNine";
import GeneralSection from "./sections/sectionGeneral";
import AccordionComponent from "../../components/accordion";
import SectionTwo from "./sections/sectionTwo";
import ServicesThirdSection from "./sections/ServicesThirdSection";
import LastSection from "./sections/LastSection";

const accordionData = [
  {
    heading: "Perfect Equipment Weight",
    body: "When choosing a medical equipment, weight has been a crucial consideration as it allows for easy lifting, installation, and transport. Although the weight of Philips ultrasonic devices varies, they are the lightest in comparison to other devices in the market.",
    imgSrc: require("../../assets/Service/According-1.png"),
  },
  {
    heading: "Large Screen Size",
    body: "The screens that come integrated with Philips ultrasound systems are sufficiently large to display all the information that is required in one configuration. This helps the doctor stay focused on the medical condition and its outcomes. With its available dimensions, Philips gained an edge in the market.",
    imgSrc: require("../../assets/Service/According-2.jfif"),
  },
  {
    heading: "Efficient Portability",
    body: "Although screen size and mobility are always inversely correlated, Philips came up with several creative concepts that defy this law. Every device is portable and readily moved from one location to another to ensure that it is maintained safe and free from any damage.",
    imgSrc: require("../../assets/Service/According-3.jfif"),
  },
  {
    heading: "High Performance",
    body: "Your initial impression when using any Philips ultrasonography medical gadget is that sense of confidence. Physicians are always looking for instantaneous, precise, and efficient data processing, which our equipment can readily do. This ensures that the device will continue to function with fewer errors and malfunctions.",
    imgSrc: require("../../assets/Service/According-4.jfif"),
  },
  {
    heading: "Premium Image Quality",
    body: "Unaffected image quality contributes to the validity of the diagnosis and surely lessen the need for expensive, time-consuming rescans. Additionally, clear images allow users to securely screen share, and stream videos straight from the system, as well as collaborate in real-time with collaborators.",
    imgSrc: require("../../assets/Service/According-5.jfif"),
  },
];

const ServicesPage = () => {
  const { firstSectionRef } = useOutletContext();

  return (
    <div className="App-header">
      <HeroSectionPrime
        imgSrc={require("../../assets/Hero/Service-Hero.jfif")}
        Align={"text-center"}
        lineHeight={"leading-loose"}
        btnAppear={true}
        title={<h2 className="text-6xl">Comprehensive Medical Technology Solutions with Full Lifecycle Support</h2>}
        content={<>
        
        H2A provides end-to-end medical solutions, including sales, marketing, and technical support for the products it represents. The company ensures reliable aftersales services such as delivery, installation, maintenance, and software updates. Its expert engineers support customers before and after purchase, ensuring smooth system integration. H2A also offers training, live demonstrations, and regular technology updates. Additionally, it provides upgrade and trade-in services to extend equipment life and keep clients up to date with the latest innovations.
        </>}
      />


      {/* <SectionTwo/> */}
      {/* <SECONDSECTION/> */}
      {/* <ThirdSection /> */}
      {/* <section className="w-full p-5 md:px-0 md:w-[80%] py-20 m-auto">
        <h3 className="text-xl md:text-[32px] leading-[44.16px]">
          Why Does H2A Offer Philips Ultrasound Equipment in Particular?
        </h3>
        <p className="text-sm md:text-[16px] leading-[29.44px] my-5 mb-20">
          Our belief at H2A is that Egyptian medical facilities ought to provide
          their patients with an improved diagnostic experience. For this
          reason, we searched the market for the best products available, but we
          were unable to find anything superior to what Philips manufactures.
        </p>
        <AccordionComponent accordionData={accordionData} dir={"l"} />
      </section> */}



<ServicesThirdSection/>

      {/* <GeneralSection
        BigTxt={
          "Empower Clinical Decisions with Sophisticated Ultrasound General Imaging"
        }
        Description={
          "In order to diagnose and guide the treatment process, Philips Ultrasound General Imaging deals with various images of parts of the body. A general imaging device should have high-performance features to optimize its functions."
        }
        Image={require("../../assets/GeneralDevices1.png")}
        backgeoundClass={"bg-[#D4D8DA]"}
        DataSource={[
          {
            Title: "Easily Share the Data with Your Team",
            Description:
              "You can share your screen data with up to six doctors on your team by connecting the general imaging device to PCs or mobile devices. In-depth team engagement and transparency are guaranteed by live collaboration.",
            image: require("../../assets/icons/post.png"),
          },
          {
            Title: "Experience High Quality Resolution",
            Description:
              "General imaging devices have an ergonomic design for comfortable scanning and a broad range of transducers that can process various types of imaging, including 2D, 3D, 4D, flat, static, and moving imaging.",
            image: require("../../assets/icons/star.png"),
          },
          {
            Title: "Keep Your System Updated All the Time",
            Description:
              "With the help of Philips, you can maintain your medical facility's competitive edge with automated updates. An update is made available on the systems as soon as it is released.",
            image: require("../../assets/icons/repeat.png"),
          },
        ]}
      />

      <GeneralSection
        BigTxt={
          "A New Perspective for Accurate Ultrasound Cardiovascular Devices"
        }
        Description={
          "When treating patients with specific heart rhythm disorders and heart failure, monitoring and controlling irregular heartbeats is made much easier with the use of cardiovascular devices. It also has exceptional features."
        }
        Image={require("../../assets/GeneralDevice2.png")}
        backgeoundClass={"imagedSectionBG bg-black text-white "}
        DataSource={[
          {
            Title: "Perfect Visualization of the Cardiac Anatomy ",
            Description:
              "With the use of virtual light, Philips' TrueVue technology enhances the visualization of cardiac anatomy in transthoracic and transesophageal echocardiograms. Furthermore, a precise 3D model of the heart anatomy is offered by Philips HeartModelA.I.",
            image: require("../../assets/icons/heart.png"),
          },
          {
            Title:
              "Automated Strain Analysis for the Left Ventricular Function",
            Description:
              "Using training data from over 6000 images, your smart system will be able to perform auto view recognition and auto contour placement. It only takes one button push to obtain a quick and precise GLS measurement.",
            image: require("../../assets/icons/heartPulse.png"),
          },
          {
            Title:
              "Better Positioning during Interventional Cardiac Procedures (EchoNavigator)",
            Description:
              "With EchoNavigator, one can better understand the anatomical structure of the heart. It integrates real-time live 3D TEE and live X-ray so that the results of the echo and X-ray scans can complement one another.",
            image: require("../../assets/icons/breath.png"),
          },
        ]}
      />

      <GeneralSection
        BigTxt={
          "Developing adequate Ultrasound Obstetrics and Gynecology Technologies."
        }
        Description={
          "The development of sharp images to verify the stages of embryonic growth is the primary goal of Philips ultrasound obstetrics and gynecology. The mother's ovaries and uterus are also visible in the live images. As with all Philips products, the features are essential. "
        }
        Image={require("../../assets/Generaldevice3.png")}
        backgeoundClass={"bg-[#D4D8DA]"}
        DataSource={[
          {
            Title: "Simple Usage and Application",
            Description:
              "FetView, a cloud-based software solution from Philips that accepts images, videos, and measurements from your ultrasound devices via a secure DICOM connection, enables a 360-degree approach to patient management.",
            image: require("../../assets/icons/upload.png"),
          },
          {
            Title: "Non-traditional Superior Capabilities ",
            Description:
              "The efficient frame rates, uniformity, and penetration of the EPIQ Elite system allow for improved visualization of fetal heart structures and vessels. MicroFlow Imaging High Definition makes it easy to detect any type of fetal blood flow disorder. ",
            image: require("../../assets/icons/Vector.png"),
          },
          {
            Title: "A Unique Encounter with a Lasting Impression",
            Description:
              "Provide fetal imaging to your patients wherever they go. With a straightforward four-measurement method, the Lumify handheld ultrasound is a versatile and user-friendly tool that facilitates quick computation of gestational age and fetal weight.",
            image: require("../../assets/icons/checkMark.png"),
          },
        ]}
      />

      <GeneralSection
        BigTxt={"Powerful Ultrasound Point of Care Units, All Functions in One"}
        Description={
          "The primary advantage of point-of-care equipment is that it can be used anywhere, at the patient's bedside, on the scene, or even in the ambulance. This device integrates ultrasound imaging directly into patient assessment and intervention."
        }
        Image={require("../../assets/GeneralDevice4.png")}
        backgeoundClass={"imagedSectionBG bg-black text-white "}
        DataSource={[
          {
            Title: "Functionality Comes with a Simple Structure ",
            Description:
              "Transfer ultrasonography to the location where your patient is. This is what the InnoSight ultrasound system's exceptional portability, cutting-edge ergonomic design, and clinical adaptability give you.",
            image: require("../../assets/icons/appRepeat.png"),
          },
          {
            Title: "In Your Hands, a Potent Scanning Device",
            Description:
              "The result of Philips fusing innovative software with military-grade hardware was the Lumify handheld ultrasound. It has a five-hour continuous scanning capacity.",
            image: require("../../assets/icons/heartDevice.png"),
          },
          {
            Title: "Simple to Use, Easy to Carry",
            Description:
              "The Ultrasound System 5000 point of care is a highly portable, hygienic, and user-friendly system with an extensive feature set and an adaptable selection of diagnostic options. ",
            image: require("../../assets/icons/repeatSetting.png"),
          },
        ]}
      /> */}

{/* 
      <SectionEight />
      <SectionNine /> */}


      <LastSection/>
    </div>
  );
};

export default ServicesPage;
